<template>
    <div class="new-card-form-c2p">
        <div class="new-card-form-c2p__header" v-text="$ml.get('addCard')" tabindex="0" />
        <div class="new-card-form-c2p__mark" v-if="showMark">
            <MarkC2P :height="32" :width="168" :card-brands="cardBrands" justify="start" />
        </div>
        <CardInputC2P
            :card-brand="cardBrand"
            :value="cardNumber"
            @input="(value) => $emit('input-number', value)"
            :error-card="cardError"
            :is-valid-errors="isValidErrors"
        />
        <CieloInputV2
            :borderless="false"
            name="Holder"
            :label="$ml.get('inputCardHolderName')"
            @input="(value) => $emit('input-holder', value)"
            :value="holder"
            v-validate="'required|fullname'"
            :data-vv-as="$ml.get('cardNameHolderValidation')"
            type="text"
            :error="errors.first('Holder')"
        />
        <div class="new-card-form-c2p__input-line">
            <CieloInputV2
                :borderless="false"
                name="ValidDate"
                :label="$ml.get('inputCardDueDate')"
                @input="(value) => $emit('input-date', value)"
                :value="validDate"
                v-validate="'required|min:4'"
                :data-vv-as="$ml.get('expiration')"
                :error="errors.first('ValidDate') || expiryError"
                type="tel"
                :mask="['##/##']"
            />
            <CieloInputV2
                :borderless="false"
                name="SecurityCode"
                label="CVV"
                @input="(value) => $emit('input-security-code', value)"
                :value="securityCode"
                v-validate="'required|min:3|max:4'"
                :data-vv-as="$ml.get('securityCode')"
                :error="errors.first('SecurityCode')"
                type="tel"
                :mask="['####']"
            />
        </div>
        <CieloSelectV2
            @change="(value) => $emit('change-installment', value)"
            :title="$ml.get('installment')"
            :label="$ml.get('installmentsNumber')"
            :option-items="installmentList"
            :selected-item="numberOfInstallments"
            :on-get-item-event="getLangOptions"
            :disabled="disableInstallment"
        />
        <InstallmentWarning />
    </div>
</template>

<script>

import CardInputC2P from '@/components/ClickToPay/template/CardInputC2P';
import CieloSelectV2 from '@/components/ClickToPay/template/CieloSelectV2/CieloSelectV2';
import MarkC2P from '@/components/ClickToPay/MarkC2P';
import { Token, Options } from '@/config/lang/genericOptions.js';
import CieloInputV2 from './template/CieloInputV2';
import CardHolderNameValidation from '@/helpers/validation-rules/CardHolderNameValidation';
import InstallmentWarning from '@/components/InstallmentWarning';

export default {
    components: {
        CardInputC2P,
        CieloInputV2,
        CieloSelectV2,
        MarkC2P,
        InstallmentWarning,
    },

    props: {
        cardBrands: {
            type: Array,
            default: () => []
        },
        cardNumber: {
            type: String,
            default: ''
        },
        cardBrand: {
            type: String,
            default: ''
        },
        holder: {
            type: String,
            default: ''
        },
        securityCode: {
            type: String,
            default: ''
        },
        validDate: {
            type: String,
            default: ''
        },
        installmentList: {
            type: Array,
            default: () => [],
        },
        numberOfInstallments: {
            type: Number,
            default: 0,
        },
        expiryError: {
            type: String,
            default: ''
        },
        cardError: {
            type: String,
            default: ''
        },
        showMark: {
            type: Boolean,
            default: true
        },
        disableInstallment: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        if (this.securityCode || this.validDate || this.holder || this.cardNumber) {
            this.$validator.validate();
            this.isValidErrors = true;
        }
        this.$validator.extend('fullname', CardHolderNameValidation);
    },

    data() {
        return {
            isValidErrors: false,
        };
    },

    methods: {
        getLangOptions(item) {
            let tokens = [];

            tokens.push(new Token('quantity', item.Value));
            tokens.push(new Token('installmentPrice', item.installmentPrice));

            return new Options('installmentsItem', tokens);
        }
    },
};
</script>

<style lang="scss" scoped>
    .new-card-form-c2p {

        &__header {
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px;
            margin-bottom: 16px;
            color: #2F363E;
        }

        &__mark {
            margin-bottom: 20px;
        }

        &__input-line {
            display: flex;
            gap: 20px;

            & >* {
                flex-grow: 1;
            }
        }
    }
</style>